<div class="citation-collapsoid">
  <button
    class="citation-toggle"
    type="button"
    (click)="toggleCitations()"
    [attr.aria-expanded]="isExpanded"
  >
    <i
      class="fa-solid"
      [class.fa-chevron-right]="!isExpanded"
      [class.fa-chevron-down]="isExpanded"
    ></i>
    <span
      >{{ citations.length }} source{{
        citations.length === 1 ? '' : 's'
      }}
      referenced</span
    >
  </button>
  @if (isExpanded) {
  <div class="citation-list">
    @for (citation of citations; track citation.file_name) {
    <div class="citation-item">
      <i class="fa-regular fa-file-lines file-icon"></i>
      <div class="citation-details">
        <span class="citation-filename">{{ citation.file_name }}</span>
        <span class="citation-time">{{
          getRelativeTime(citation.updated_at)
        }}</span>
      </div>
    </div>
    }
  </div>
  }
</div>
